import React from "react";

const Jobs = () => {
  return (
    <div className="container mt-4">
      <style>{`
        .job-card { box-shadow:0 4px 15px rgba(0,0,0,0.1); border-radius:10px; }
      `}</style>

      <h4>Jobs</h4>

      <div className="row">
        {[1,2,3,4,5,6].map(i => (
          <div key={i} className="col-md-4 mb-3">
            <div className="card p-3 job-card">
              <h6>Senior Developer</h6>
              <small>25 Applicants</small>

              <p className="small mt-2">
                📍 USA <br/>
                💰 30k/month <br/>
                ⏳ 2 years exp
              </p>

              <div className="progress">
                <div className="progress-bar" style={{width:"70%"}}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Jobs;